import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LocationDto } from '@braoshzmvavz/picnube-common';
import { sortLocations } from '../../utils/SortUtils';

interface LocationState {
    locations: LocationDto[];
    loading: boolean;
    error: string | null;
}

const initialState: LocationState = {
    locations: [],
    loading: false,
    error: null,
};

export const locationSlice = createSlice({
    name: 'location',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        resetLocationsToInitialState: state => {
            state.locations = []
            state.loading = false
            state.error = null
        },

        setLocations: (state, action: PayloadAction<LocationDto[]>) => {
            state.locations = sortLocations(action.payload);
        },

        setLocationsLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },

        addLocation: (state, action: PayloadAction<LocationDto>) => {
            // Add the new location and resort the entire array
            const newLocations = [...state.locations, action.payload];
            state.locations = sortLocations(newLocations);
        },

        updateLocationState: (state, action: PayloadAction<LocationDto>) => {
            console.log('UPDATELOCATIONSTATE', state.locations, action.payload)
            // Update the location and resort the array
            const updatedLocations = state.locations.map((location) => {
                if (location.id === action.payload.id) {
                    return action.payload;
                }
                return location;
            });
            state.locations = sortLocations(updatedLocations);
        },

        removeLocation: (state, action: PayloadAction<string>) => {
            state.locations = state.locations.filter((location) => location.id !== action.payload);
        },
    }
})

export const {
    resetLocationsToInitialState,
    setLocations,
    setLocationsLoading,
    addLocation,
    removeLocation,
    updateLocationState,
} = locationSlice.actions

export default locationSlice.reducer